<template>
    <div class="row mt-5" id="login">
        <div class="offset-md-3 col-md-6">

            <div class="bg-white p-4 shadow-sm rounded-lg mb-5">
                <div class="mb-3"> 
                    <img src="../assets/signature.png" style="height:48px">
                </div>

                <Alerts :_success="success" :_error="error"></Alerts>

                
                <div class="form-group mb-3">
                    <a :href="`${appUrl}/auth/google`">
                        <img src="../assets/login_with_google.png" class="w-50"/>
                    </a>
                </div>
                <hr>

                <form v-if="showForm" @submit.prevent="login()">
                    <div class="form-group mb-3">
                        <label class="font-weight-bold">E-Mail Address</label>
                        <input id="email" type="email" class="form-control rounded-lg" name="email" required
                               autocomplete="email" ref="email"
                               v-model="auth.email" autofocus placeholder="E-Mail Address" :disabled="wait">
                    </div>

                    <div class="form-group mb-3">
                        <label class="font-weight-bold">Password</label>
                        <input id="password" type="password" class="form-control" name="password" required
                               v-model="auth.password" autocomplete="current-password" placeholder="Your Password"
                               :disabled="wait">
                    </div>

                    <div class="form-group">
                        <vue-recaptcha
                            ref="recaptcha"
                            @verify="onVerified"
                            @expired="onExpired"
                            :sitekey="sitekey">
                        </vue-recaptcha>
                    </div>

                    <div class="form-group mb-3">
                        <button type="submit" class="btn btn-dark" :disabled="wait || !auth.recaptcha_token">
                            <div v-if="wait" class="spinner-border spinner-border-sm mr-2"></div>
                            <span>Login</span>
                        </button>
                    </div>

                    <div class="form-group mb-3">
                        <router-link to="/recover">Forgot Password?</router-link>
                    </div>

                </form>
            </div>


            <div class="text-center">
                <img src="../assets/oi_logo.png" class="mb-2" style="height: 38px">
                <p>Powered by the <a href="https://openinstitute.africa/" target="_blank">The Open Institute</a></p>
            </div>
        </div>
    </div>
</template>

<script>
import {VueRecaptcha} from 'vue-recaptcha';
import Alerts from "./Alerts";

export default {
    name: "Login",
    components: {Alerts, VueRecaptcha},
    data() {
        return {
            showForm: true,
            auth: {
                email: '',
                password: '',
                recaptcha_token: ''
            },
            sitekey: process.env.VUE_APP_SITE_KEY,
            appUrl: process.env.VUE_APP_URL
        }
    },
    computed: {
        isDemo() {
            return JSON.parse(process.env.VUE_APP_DEMO || 'false');
        },
    },
    mounted() {
        console.log(this.isDemo)
        if (this.isDemo) {
            this.auth.email = 'demo@example.com';
            this.auth.password = 'password123';
        }
        this.$refs.email.focus();
    },
    methods: {
        onExpired: function () {
            this.resetRecaptcha()
        },
        onVerified: function (token) {
            this.auth.recaptcha_token = token
        },
        resetRecaptcha() {
            this.$refs.recaptcha.reset();
            this.auth.recaptcha_token = ''
        },
        login() {
            this.wait = true
            this.clear()
            this.success = "Connecting to auth server. Please wait..."

            this.$http.post('/token', this.auth).then(response => {
                let user = response.data.data.user

                this.$toast.success(`Welcome ${user.fname}!`)
                this.showForm = false
                this.success = `Welcome ${user.fname}. Redirecting you to your dashboard...`

                localStorage.setItem('token', response.data.data.token)
                localStorage.setItem('user', JSON.stringify(user))

                setTimeout(() => (window.location.href = '/home'), 500)

            }).catch(error => {
                this.showError(error)
                this.resetRecaptcha()

            }).then(() => {
                this.wait = false
            })
        }
    }
}
</script>

<style scoped>
.g-recaptcha {
    transform: scale(0.60);
    transform-origin: 0 0;
}
</style>
